// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"resetPassword_btnBlue_23BQm","btnBlueOutline":"resetPassword_btnBlueOutline_h0hWS","invalidCoding":"resetPassword_invalidCoding_1VABM","form":"resetPassword_form_WGwUq"};